import { Component } from '@angular/core';
import { Event,Router, RouterEvent } from '@angular/router';
import { Platform } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { ApiService } from './services/api.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  platformReady:boolean = false;
  constructor(private platform:Platform, public router: Router ) {
    this.initializeApp();
  }
  initializeApp(){
    this.platform.ready().then( ()=>{
      this.platformReady=true;
          this.router.events.pipe(
             filter((e: Event): e is RouterEvent => e instanceof RouterEvent)
             ).subscribe((e:RouterEvent)=>{
               if(e.constructor.name == 'RoutesRecognized'){

                 console.log(e);
               }
            })

    })

  }
}
